import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const Notes: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_12280_29072)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M15.6046 16.1805C15.6046 16.3646 15.4479 16.5134 15.2551 16.5134L11.5622 16.5144C11.3663 16.5144 11.2096 16.3655 11.2096 16.1814C11.2096 15.9973 11.3663 15.8485 11.5622 15.8485H15.2551C15.4479 15.8475 15.6046 15.9964 15.6046 16.1805ZM19.3007 13.6794C19.3007 13.8635 19.144 14.0124 18.9481 14.0124H11.5623C11.3664 14.0124 11.2097 13.8635 11.2097 13.6794C11.2097 13.4953 11.3664 13.3465 11.5623 13.3465H18.9481C19.144 13.3465 19.3007 13.4944 19.3007 13.6794ZM19.3007 11.1784C19.3007 11.3625 19.144 11.5114 18.9481 11.5114H11.5623C11.3664 11.5114 11.2097 11.3625 11.2097 11.1784C11.2097 10.9943 11.3664 10.8455 11.5623 10.8455H18.9481C19.144 10.8445 19.3007 10.9933 19.3007 11.1784ZM11.5179 7.01949C11.8231 7.01949 12.0695 7.25451 12.0695 7.5424C12.0695 7.83127 11.8231 8.06629 11.5179 8.06629C11.2158 8.06629 10.9663 7.83127 10.9663 7.5424C10.9653 7.25451 11.2148 7.01949 11.5179 7.01949ZM21.2979 21.5898V6.11174C21.2979 5.70144 20.9453 5.36948 20.5143 5.36948H12.8759C12.7666 5.81209 12.5645 6.23122 12.2851 6.60432C12.579 6.82269 12.7718 7.16251 12.7718 7.54343C12.7718 8.19953 12.2078 8.7342 11.5171 8.7342C10.8263 8.7342 10.2654 8.20051 10.2654 7.54343C10.2654 6.85697 10.8758 6.31054 11.6036 6.35657C11.8531 6.06278 12.0367 5.72789 12.149 5.36948L9.2128 5.3685V21.5898C9.2128 21.9991 9.56539 22.3321 9.99636 22.3321H20.5153C20.9442 22.3321 21.2979 21.9991 21.2979 21.5898ZM6.23426 19.9358C5.88991 19.8604 5.6765 19.5333 5.75692 19.2073L8.51262 7.9428V20.4381L6.23426 19.9358ZM2.95993 16.7699L5.32708 18.0223L7.95815 7.26526L2.76399 16.1176C2.6279 16.3497 2.71765 16.6396 2.95993 16.7699ZM6.20233 4.54978C6.20233 2.95946 7.56426 1.66585 9.23648 1.66585C10.9737 1.66585 12.3646 3.05444 12.2675 4.70245H8.86328C8.64677 4.70245 8.5643 4.87088 8.55501 4.87479L7.40134 6.84604C6.65286 6.30352 6.20233 5.45559 6.20233 4.54978ZM20.5145 4.70254H12.9708C12.9739 4.65162 12.977 4.6007 12.977 4.55076C12.977 2.59225 11.2986 1 9.23659 1C7.17772 1 5.49933 2.59228 5.49933 4.55076C5.49933 5.69746 6.087 6.77073 7.05713 7.43368L2.15065 15.7947C1.83003 16.345 2.03724 17.0461 2.61973 17.3526L5.16213 18.6981L5.07346 19.0575C4.90748 19.742 5.35492 20.4275 6.07558 20.5871L8.51386 21.1247V21.5909C8.51386 22.3684 9.1778 23 9.99744 23H20.5164C21.335 23 22 22.3684 22 21.5909L21.9979 6.11182C21.9979 5.33428 21.3331 4.70254 20.5145 4.70254Z'
          fill='url(#paint0_linear_12280_29072)'
          stroke='url(#paint1_linear_12280_29072)'
          strokeWidth='0.8'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_12280_29072'
          x1='6.14154'
          y1='2.50015'
          x2='16.7266'
          y2='21.7869'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_12280_29072'
          x1='6.14154'
          y1='2.50015'
          x2='16.7266'
          y2='21.7869'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <clipPath id='clip0_12280_29072'>
          <rect
            width='24'
            height='24'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Notes;
